import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      '& .MuiPaper-root': {
        width: '320px',
        background: theme.palette.background.default,
        padding: '1rem',
      },
    },
    openModalButton: {
      background: '#E1E1E1',
    },
    email: {
      width: '100%',
      background: ' #fff',
      borderRadius: '5px',
      padding: theme.spacing(2, 2, 0, 2),

      '& > .MuiTypography-body1': {
        fontWeight: 600,
      },

      '& > .MuiTypography-subtitle1': {
        marginBottom: '1.5rem',
      },
    },
    iconButton: {
      margin: 0,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'start',
      gap: theme.spacing(3.25),
      padding: 0,
      marginBottom: '1rem',

      '&:active': {
        transform: 'none',
        boxShadow: 'none',
      },
    },
    paper: {
      display: 'flex',
      flexDirection: 'column',
    },
  }),
)
